import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass, textEllipsis } from '../../../style';
import { PageHeaderStyles } from '../../layout/PageHeaderStyles';

const cssPrefix = 'Breadcrumbs';

const focusBorderSize = CommonStyles.Focus.IndicatorWidth;
const listLeftMargin = 3;
const focusPadding = 5;

export namespace BreadcrumbStyles {
  export const BreadcrumbContainerInTopBar = cssClass(cssPrefix, 'container', textEllipsis, {
    fontWeight: 'bold',
    display: 'inline-block',
    flexShrink: 0,
    height: PageHeaderStyles.height,
    lineHeight: PageHeaderStyles.height,
    fontSize: CommonStyles.Sizes.NormalFontSize,
    marginLeft: '-' + (focusBorderSize + listLeftMargin + focusPadding) + 'px'
      // need to subtract some pixels since we have padding around all the breadcrumbs for the focus indicator
  });

  export const BreadcrumbList = cssClass(cssPrefix, 'list', {
    listStyle: 'none',
    margin: '0',
    paddingLeft: '0',
    marginLeft: listLeftMargin + 'px' // so that the focus indicator shows completely
  });

  const BreadcrumbStyles: CSSProperties = {
    fontSize: CommonStyles.Sizes.NormalFontSize,
    display: 'inline'
  };

  export const Breadcrumb = cssClass(cssPrefix, 'breadcrumb', {
    ...BreadcrumbStyles,
  });

  export const Focus = cssClass(cssPrefix, 'breadcrumb-focus', {
    border: focusBorderSize + 'px solid transparent',
    boxSizing: 'border-box',
    padding: focusPadding + 'px',  // with the border, this makes for 6px around the link
    $nest: {
      '&:focus': CommonStyles.Focus.Indicator
    }
  });

  export const NonLinkBreadcrumbText = cssClass(cssPrefix, 'breadcrumb-non-link-text', {
    paddingLeft: (focusPadding + focusBorderSize) + 'px',  // so have same padding between text or link and divider 
    paddingRight: (focusPadding + focusBorderSize) + 'px'
  });

  export const NonLinkBreadcrumb = cssClass(cssPrefix, 'breadcrumb-non-link', {
    ...BreadcrumbStyles,
    fontWeight: 'normal',
  });

  export const BreadcrumbDivider = cssClass(cssPrefix, 'divider', {
    fontWeight: 'normal',
    cursor: 'default',
    paddingRight: '0px'  // all the links have padding and that's plenty
  });
}
